/**
 * Classes of the mobile visual layer (AD-016/AD-018). Always `max-md:` when
 * the component also renders at >= 768px, so the desktop keeps its current
 * look. Usage: `cn(base, mobileLayer.touch, className)`.
 */
export const mobileLayer = {
  card: 'max-md:rounded-mobile-card',
  /** Only in components that never render at >= 768px. */
  sheet: 'rounded-t-mobile-sheet',
  /** Only in components that never render at >= 768px (chips are mobile-only). */
  chip: 'rounded-full',
  touch: 'max-md:min-h-touch max-md:min-w-touch',
  input: 'max-md:text-base',
} as const;
